import { motion } from "framer-motion";
import { ShieldCheck, RefreshCw, Clock, HeartHandshake, CheckCircle } from "lucide-react";

const guarantees = [
  {
    icon: ShieldCheck,
    title: "Satisfait ou remboursé",
    description: "14 jours pour changer d'avis. Si le résultat ne vous plaît pas, on vous rembourse intégralement.",
  },
  {
    icon: RefreshCw,
    title: "Révisions incluses",
    description: "Chaque formule inclut des sessions de révision. Votre portfolio doit être parfait.",
  },
  {
    icon: Clock,
    title: "Livraison garantie",
    description: "48h pour Clé en main, 72h pour Starter. Retard = remise. On respecte nos délais.",
  },
  {
    icon: HeartHandshake,
    title: "Accompagnement humain",
    description: "Un vrai interlocuteur, pas un chatbot. On échange jusqu'à ce que vous soyez satisfait.",
  },
];

const SellGuarantee = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent" />
      
      <div className="container mx-auto px-6 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            <ShieldCheck className="w-4 h-4" />
            Zéro risque
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Notre engagement{" "}
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              qualité
            </span>
          </h2>
          <p className="text-muted-foreground text-sm sm:text-lg max-w-2xl mx-auto">
            Commander n'a jamais été aussi sûr. Votre satisfaction est notre seule priorité.
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-6">
          {guarantees.map((g, i) => (
            <motion.div
              key={g.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="flex gap-4 p-6 rounded-2xl bg-card/60 border border-border/40 hover:border-primary/30 transition-colors group"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                <g.icon className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-bold text-base sm:text-lg mb-1">{g.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{g.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Trust seal */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="mt-12 flex justify-center"
        >
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-2xl bg-card border border-primary/20 shadow-lg shadow-primary/5">
            <div className="w-10 h-10 rounded-full bg-gradient-to-r from-primary to-accent flex items-center justify-center">
              <CheckCircle className="w-5 h-5 text-primary-foreground" />
            </div>
            <div className="text-left">
              <p className="text-sm font-bold">Paiement 100% sécurisé</p>
              <p className="text-xs text-muted-foreground">Stripe · SSL · Données chiffrées</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SellGuarantee;
